import axios from 'axios';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Media from 'react-media';

import { Flex, Text, Spinner } from "../../../../components";
import License from "./License";
import { Modal, ModalContainer, ModalButton, Input, Select, Label, TextArea } from "../../components";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Pagination from '@mui/material/Pagination';
import ReactTooltip from 'react-tooltip';

const Header = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 15px 30px;
`;

const Search = styled.input`
  background: transparent;
  flex-grow: 1;
  margin-right: 20px;
  height: 100%;
  color: #fff;
  
  &::placeholder {
    color: #7178B2
  }
`;

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg}
`;

const Content = styled(Flex)`
  padding: 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;


const Licenses = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [licenses, setLicenses] = useState(false);
  const [licensesCount, setLicensesCount] = useState(null);
  const [licenseTypes, setLicenseTypes] = useState(false);
  const [generatedKeys, setGeneratedKeys] = useState(null);

  const [showModal, setModal] = useState(false);
  const [showGeneratedKeys, setShowGeneratedKeys] = useState(false);
  const [keyPayload, setKeyPayload] = useState({
    keyType: 0,
    quantity: 1,
  });

  const [licensesPage, setLicensesPage] = useState(0);

  const revealModal = () => {
    if (licenseTypes.length > 0) {
      setModal(true)
    } else {
      NotificationManager.error('Missing License Types', '');
    }
  };

  const renderLicensesPagination = () => {

    return (
      <Pagination onChange={(e, val) => pullLicensesPage(val)} count={Math.round(licensesCount / 10)} page={licensesPage} variant="outlined" color="primary" shape="rounded" />
    )

  }

  const pullLicensesPage = (page) => {
    setIsLoading(true);
    axios
      .get(`/api/admin/licenses/list/${page}`)
      .then(res => {
        setLicenses(res.data.licenses);
        setLicensesPage(page);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }


  const hideModal = () => setModal(false);


  useEffect(() => {
    axios
      .get('/api/admin/licenses/list/0')
      .then(res => {
        setLicenses(res.data.licenses);
        setLicensesCount(res.data.licensesCount);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
    axios
      .get('/api/admin/licenses/license-types')
      .then(res => {
        setLicenseTypes(res.data.licenseTypes);
        setKeyPayload({
          ...keyPayload,
          keyType: res.data.licenseTypes.length > 0 ? res.data.licenseTypes[0].id : 0
        })
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  const refreshList = () => {
    setIsLoading(true);

    axios
      .get('/api/admin/licenses/list')
      .then(res => {
        setLicenses(res.data.licenses);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });

  }

  const renderLicenseTypes = () => {

    return (
      <Select
        value={keyPayload.type}
        onChange={(e) => {
          setKeyPayload({
            ...keyPayload,
            keyType: e.target.value
          })
        }}
      >
        {licenseTypes.map((value) => {
          return <option value={value.id}>{value.name} | {value.label}</option>
        })}
      </Select>
    )

  }

  const displayGeneratedKeys = (keys) => {
    let s = '';
    for (let i = 0; i < keys.length; i++) {
      s += `${keys[i]} \r`;
    }
    setGeneratedKeys(s);
    setShowGeneratedKeys(true);
  }

  const createKeys = () => {
    setIsLoading(true);

    axios
      .post(`/api/admin/licenses/generate-license?type=${keyPayload.keyType}&quantity=${keyPayload.quantity}`)
      .then(res => {
        displayGeneratedKeys(res.data.keys);
        setLicenses(res.data.licenses.rows);
        setLicensesCount(res.data.licenses.count);
        setIsLoading(false);
        hideModal();
      })
      .catch(err => {
        console.error(err);
      });

  }

  const searchLicense = (value) => {

    setIsLoading(true);

    if (value.length > 0) {

      axios
        .get('/api/admin/licenses/search-licenses?search=' + value)
        .then(res => {
          setLicenses(res.data.licenses);
          setIsLoading(false);
        })
        .catch(err => {
          console.error(err);
        });

    } else {
      axios
        .get('/api/admin/licenses/list/0')
        .then(res => {
          setLicenses(res.data.licenses);
          setIsLoading(false);
        })
        .catch(err => {
          console.error(err);
        });
    }

  }

  return (
    <>
      <Media query={{ maxWidth: 700 }}>
        {matches => (
          <Header dir={matches && 'column'} h={!matches && '90px'} w="100%" align={!matches && 'center'}>
            <Search placeholder="Search licenses" onKeyPress={e => e.key == "Enter" ? searchLicense(e.target.value) : ""} />
            <Flex fg="1" h="24px" />
            <Flex>
              <Button bg="#0393FF" onClick={revealModal}>Generate Key</Button>
              <Flex w="12px" />
              <Button bg="#F32FE0" onClick={() => refreshList()}>Refresh List</Button>
            </Flex>
          </Header>
        )}
      </Media>
      <Content w="100%" minw="660px" dir="column">
        <HeaderRow w="100%" minw="600px">
          <Flex w="25%">Discord ID</Flex>
          <Flex w="25%">Type</Flex>
          <Flex w="25%">Renewal</Flex>
          <Flex w="25%">Status</Flex>
        </HeaderRow>

        {licenses.map((value) => {
          if (value != null)
            return <License data={value} />
        })}
      </Content>
      {renderLicensesPagination()}

      <NotificationContainer />

      {showModal &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Generate Key</Text.Heading>
            <Flex h="24px" />
            <Label>Key Type</Label>
            <Flex h="16px" />
            {renderLicenseTypes()}
            <Flex h="24px" />
            <Label>Quantity</Label>
            <Flex h="16px" />
            <Input
              type="number"
              placeholder="1"
              value={keyPayload.quantity}
              onChange={(e) => {
                setKeyPayload({
                  ...keyPayload,
                  quantity: e.target.value
                })
              }}
            />
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={hideModal} bg="#202441">Cancel</ModalButton>
              <Flex w="16px" />
              <ModalButton bg="#F32FE0" onClick={createKeys}>Create Keys</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      {showGeneratedKeys &&
        <ModalContainer>
          <Modal dir="column">
            <Text.Heading size="18">Generated Key(s)</Text.Heading>
            <Flex h="24px" />
            <TextArea>{generatedKeys}
            </TextArea>
            <Flex h="24px" />
            <Flex dir="row" w="100%">
              <ModalButton onClick={() => setShowGeneratedKeys(false)} bg="#202441">Close</ModalButton>
            </Flex>
          </Modal>
        </ModalContainer>
      }

      <ReactTooltip />
    </>
  )
}

export default Licenses;
